import CallButton from '../components/CallButton';
import React, { useEffect } from 'react'
import { FaChevronLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';


export default function BackgroundImgBlur({src, title, content, hscreen}) {

    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])


  const navigate = useNavigate();

    return <>
        <div className='overflow-y-auto'>
            <div className="fixed top-0 left-0 w-full h-full bg-cover bg-center"
                style={{ backgroundImage: `url(${src})` }}>
            </div>
            <div className={`relative z-10 text-white glassmorphism-trattamenti pt-20 ${hscreen ? 'h-screen' : ''}`}>
            <div className='fixed top-[15px] left-[15px] z-50'>
                <button onClick={() => navigate(-1)} 
                // className={`px-8 py-2 uppercase border border-slate-50 text-slate-50 progress-button-light transition duration-300 ease-in-out `}
                className='flex border p-2 rounded bg-[#65806E] border-[#65806E]'
                >
                <FaChevronLeft className='mt-1' /> <span className='pl-1'>INDIETRO</span>
                </button>
            </div>
                <div className='relative z-10 text-white '>
                    <div className='text-center w-full mx-auto p-5'>
                        <h1 className={`text-4xl font-semibold uppercase mb-[6.5rem] text-mcare panoragraf-light`} data-aos="fade-up" data-aos-duration="900" >{title}</h1>
                        {content}
                    </div>
                </div>
            </div>
            <CallButton />
        </div>
    </>
}